
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/curiosity",
      function () {
        return require("private-next-pages/blog/curiosity.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/curiosity"])
      });
    }
  